// =================================================
// Gestion des informations  Freemium
// =================================================
export function isFreemiumAuthorized(user) {
  return user.hasOwnProperty('freemiumIsAuthorized') ? user.freemiumIsAuthorized : false;
}
export function getUserVideosPeriod(user){
  return user.hasOwnProperty('freemiumVideosPeriod') ? user.freemiumVideosPeriod : 0;
}
export function getUserVideosAuthorized(user){
  return user.hasOwnProperty('freemiumVideosAuthorized') ? user.freemiumVideosAuthorized : 0;
}
export function getUserVideosLeft(user){
  return user.hasOwnProperty('freemiumVideosLeft') ? user.freemiumVideosLeft : 0;
}
export function getUserVideosSeen(user){
  return user.hasOwnProperty('freemiumVideosSeen') ? user.freemiumVideosSeen : 0;
}


/**
 * Méthode permettant de savoir si un utilisateur à vu la vidéo
 * @param {object} user Utilisateur courant
 * @param {object} video Vidéo courante
 * @returns 
 */
export function userVideoSeen(user, video) {
  const videoUser = user.userVideos.find(uv => uv.video === video['@id']);

  if (typeof videoUser === 'undefined') {
    return false;
  }

  return true;
}

/**
 * Méthode permettant de récupérer la progression maximale de l'utilisateur pour la vidéo
 * @param {object} user Utilisateur courant
 * @param {object} video Vidéo courante
 * @returns 
 */
export function userVideoProgress(user, video) {
  const videoUser = user.userVideos.find(uv => uv.video === video['@id']);

  if (typeof videoUser === 'undefined' || !videoUser.progress) {
    return 0;
  }

  return videoUser.progress;
}

/**
 * Méthode permettant de récupérer la dernière progression pour la vidéo
 * @param {object} user Utilisateur courant
 * @param {object} video Vidéo courante
 * @returns 
 */
 export function userVideoLastProgress(user, video) {
  const videoUser = user.userVideos.find(uv => uv.video === video['@id']);

  if (typeof videoUser === 'undefined' || !videoUser.lastProgress) {
    return 0;
  }

  return videoUser.lastProgress;
}

/**
 * Méthode permettant de récupérer la dernière durée de visionnage d'une vidéo par un utilisateur
 * @param {object} user Utilisateur courant
 * @param {object} video Vidéo courante
 * @returns 
 */
 export function userLastVideoDuration(user, video, videoDuration) {
  const lastProgress = userVideoLastProgress(user, video);
  if (!lastProgress && lastProgress <= 0) {
    return 0;
  }
  return Math.round((lastProgress / 100) * videoDuration);
}

/**
 * Méthode permettant de savoir si la vidéo a été ajouté après la dernière connexion de l'utilisateur
 * @param {object} user Utilisateur courant
 * @param {object} video Vidéo courante
 * @returns 
 */
export function userLastVideo(user, video) {
  const createVideo = video.createdAt;
  const previousConnectionUser = user.previousConnection;

  if (previousConnectionUser === null || (createVideo > previousConnectionUser && !userVideoSeen(user, video))) {
    return true;
  }

  return false;
}
